var map = {
	"./assets/img/for-example/cute-beetroot.png": 5321,
	"./assets/img/for-example/cute-cartoon-green-peas.png": 4277,
	"./assets/img/for-example/happy-corn.png": 3054,
	"./assets/img/for-example/smiling-carrot.png": 1052,
	"./assets/img/products/mezuza.webp": 6781,
	"./assets/img/products/tfiling.jpg": 286,
	"./assets/img/stories/contemplative-reptile.jpg": 9303,
	"./assets/logo/Chabad-logo.jpeg": 3750,
	"./assets/logo/Chabad-logo.png": 6041,
	"./assets/logo/Chabad-logo.psd": 3752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;